var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro__container"},[_c('prismic-rich-text',{staticClass:"intro__highlight",class:_vm.slice.primary.english && 'eng eng_highlight',attrs:{"field":_vm.slice.primary.highlight_intro}}),_c('prismic-rich-text',{staticClass:"intro__text",class:_vm.slice.primary.english && 'eng eng_text',attrs:{"field":_vm.slice.primary.intro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }